var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnterRightarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1475 12.3971L14.3975 19.1471C14.2909 19.2465 14.1498 19.3006 14.0041 19.298C13.8584 19.2955 13.7193 19.2364 13.6163 19.1334C13.5132 19.0303 13.4542 18.8913 13.4516 18.7455C13.449 18.5998 13.5031 18.4588 13.6025 18.3521L19.3916 12.5621H4.25C4.10082 12.5621 3.95774 12.5029 3.85225 12.3974C3.74676 12.2919 3.6875 12.1488 3.6875 11.9996C3.6875 11.8505 3.74676 11.7074 3.85225 11.6019C3.95774 11.4964 4.10082 11.4371 4.25 11.4371H19.3916L13.6025 5.64714C13.5031 5.54051 13.449 5.39947 13.4516 5.25375C13.4542 5.10802 13.5132 4.96898 13.6163 4.86592C13.7193 4.76286 13.8584 4.70383 14.0041 4.70126C14.1498 4.69869 14.2909 4.75278 14.3975 4.85214L21.1475 11.6021C21.2528 11.7076 21.312 11.8506 21.312 11.9996C21.312 12.1487 21.2528 12.2917 21.1475 12.3971Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterRightarrow);
export default __webpack_public_path__ + "static/media/enterRightarrow.c450dbba34f3631e9b45db4d00e474b8.svg";
export { ForwardRef as ReactComponent };